import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M20,18.586 L18.586,20 L12.929,14.343 L14.343,12.929 L20,18.586 Z M7,12 C4.243,12 2,9.757 2,7 C2,4.243 4.243,2 7,2 C9.757,2 12,4.243 12,7 C12,9.757 9.757,12 7,12 L7,12 Z M7,0 C3.134,0 0,3.134 0,7 C0,10.866 3.134,14 7,14 C10.866,14 14,10.866 14,7 C14,3.134 10.866,0 7,0 L7,0 Z"
      id="path-1"
    />
  </svg>
);
